<template>
  <div
    class="drop-area"
    @dragenter="dragEnter"
    @dragover="dragOver"
    @dragleave="dragLeave"
    @drop="drop"
    :class="{ 'highlight': highlight, 'loading': loading }"
    @click="clickBtn"
  >
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    <form class="my-form">
      <p>Upload multiple files with the file dialog or by dragging and dropping images onto the dashed region</p>
      <input type="file" ref="btn" class="fileElem" multiple :accept="filetype" @change="handleFiles">
    </form>
    <div class="gallery">
      <div class="gallery-item done" v-for="(image, i) in files" :key="'done-' + i" @click.stop="removeOldFile(i)">
        <img :src="(image.url ? image.url : image)" class="done">
        <div class="overlay">
          <v-icon class="text" color="error">delete</v-icon>
        </div>
        <br/>
        <span v-if="filenames" class="filename">{{image.key}}</span>
      </div>
      <div class="gallery-item todo" v-for="(image, i) in images" :key="'todo-' + i" @click.stop="removeTodoFile(i)">
        <img :src="image" class="todo">
        <div class="overlay active">
          <v-icon class="text" color="primary">add</v-icon>
        </div>
        <div class="overlay">
          <v-icon class="text" color="error">delete</v-icon>
        </div>
        <br/>
        <span v-if="filenames" class="filename">{{newFiles[i].name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropzone',
  components: {
  },
  props: {
    files: {
      type: Array,
      default: undefined,
    },
    filetype: {
      type: String,
      default: 'image/*',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filenames: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      highlight: false,
      images: [],
      newFiles: [],
    };
  },
  methods: {
    dragEnter() {
    },
    dragOver(e) {
      this.highlight = true;
      e.preventDefault();
    },
    dragLeave() {
      this.highlight = false;
    },
    drop(e) {
      e.preventDefault();
      this.highlight = false;
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        this.newFiles.push(e.dataTransfer.files[i]);

        if (e.dataTransfer.files[i].type.indexOf('image/') === -1) {
          this.images.push('/img/file.png');
        } else {
          this.images.push(URL.createObjectURL(e.dataTransfer.files[i]));
        }
      }
    },
    handleFiles() {
      for (let i = 0; i < this.$refs.btn.files.length; i += 1) {
        this.newFiles.push(this.$refs.btn.files[i]);

        if (this.$refs.btn.files[i].type.indexOf('image/') === -1) {
          this.images.push('/img/file.png');
        } else {
          this.images.push(URL.createObjectURL(this.$refs.btn.files[i]));
        }
      }
    },
    removeOldFile(e) {
      this.$emit('removeFile', e);
    },
    removeTodoFile(e) {
      this.newFiles.splice(e, 1);
      this.images.splice(e, 1);
    },
    clickBtn() {
      this.$refs.btn.click();
    },
    getFileList() {
      return this.newFiles;
    },
    clear() {
      this.newFiles = [];
      this.images = [];
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
  .drop-area {
    border: 2px dashed #ccc;
    border-radius: 20px;
    width: 100%;
    font-family: sans-serif;
    margin: 20px auto;
    min-height: 200px;
    padding: 20px;
    cursor: pointer;
  }
  .drop-area.highlight {
    border-color: purple;
  }
  .drop-area.loading {
    background-color: rgba(0,0,0,0.2);
  }
  p {
    margin-top: 0;
  }
  .my-form {
    margin-bottom: 10px;
  }
  #gallery {
    margin-top: 10px;
  }
  .gallery img {
    width: 150px;
    vertical-align: middle;
  }
  .button {
    display: inline-block;
    padding: 10px;
    background: #ccc;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  .button:hover {
    background: #ddd;
  }
  .fileElem {
    display: none;
  }

  .gallery .gallery-item {
    display: inline-block;
  }

  img.done {

  }

  img.todo {

  }

  .gallery-item {
    position: relative;
    margin-bottom: 10px;
    margin-right: 10px;
    text-align: center;
  }

  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
    background-color: rgba(255,255,255,0.8);
  }

  .overlay.active {
    opacity: 1;
    background-color: rgba(0,0,0,0.4);
  }

  .gallery-item:hover .overlay {
    opacity: 1;
  }

  .gallery-item:hover .overlay.active {
    opacity: 0;
  }

  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .filename {
    font-size: 10pt;
  }
</style>
